function MainCarousel(){

    console.log("main carousel called");

    var self = this;

    self.$player = $("#home-promo");
    self.$videoContainer = $("#video-container");
    self.$video = $("#promo-video");

   // this.$player = $(holder);
   // this.$video = $(video);

    self.slides = [];
    self.length = $(".text-inner-container .text").length;


    console.log("length "+ self.length);

    function timelineComplete() {

        console.log("complete");

        self.tl.seek(0);
        self.tl.play();

    }

    self.tl = new TimelineMax({paused: true, onComplete: timelineComplete});



    if (self.$player.hasClass("hasVideo")) {

        console.log("------------- has video");

       // $(window).resize(function () {
         //  self.sizeVideo();
       // });

        self.videoPlayer("promo-video", 1400/480);

      //  self.sizeVideo();

       // console.log("rigeoigeibge");

        for (var i = 0; i < self.length; i++) {

            var t = new TextSlide(i, self);

            self.slides.push(t);

            self.tl.add(t.getTimeline());


        }

        console.log("rigeoigeibge");

        if(self.length ===1){

            self.tl.seek(1);

            //console.log("play 1");

        } else {

            self.tl.play();

            //console.log("play all");
        }

    } else {

        self.$previousImage = $("#previous-image");
        self.$currentImage = $("#current-image");

        for (var j = 0; j < self.length; j++) {

            var s = new Slide(j, self);

            self.slides.push(s);

            self.tl.add(s.getTimeline());
        }

        if(self.length ===1){

            self.tl.seek(1);


        } else {

            self.tl.play();
        }

        this.$currentImage.html(self.slides[0].image);
    }

   // self.videoPlayer("promo-video", 1400/480);

}

MainCarousel.prototype.videoPlayer= function(id, ratio){

    //console.log("my video player");

    var self = this;

    this.ratio = ratio;

    var playerID = "#"+ id;



    this.$play = $(".play");

    if (Modernizr.touch){
        self.switchDelay = 0.7;
    }


    var player = videojs(id, { /* Options */

        "controls": false,
        "autoplay": true,
        "preload": "auto"


    }, function() {



        self.myPlayer = this;



        this.on('ended', function() {


            player.play();
            //window.history.back();
        });


       // self.sizeVideo();

        //self.resize();
    });

    var flag = false;

    console.log("play video");

    player.play();

};


MainCarousel.prototype.sizeVideo = function(){

    console.log("size video called");

    var self = this;

    var ph = self.$player.height();
    var pw = self.$player.width()+10;
   // var pCw = self.$video.width();

    var ratio = 1400 / 480;

    //console.log("pw " + pw);

    if (pw < 1400){

        console.log("pw < 1400 ");

        var left = -(1400 - pw) / 2;

        //console.log("less than");
       // TweenMax.set(self.$videoContainer, {width: 1400,height: 480, left:left});

        TweenMax.set(self.$videoContainer, {width: 1400,height: 260, left:left});
        TweenMax.set(self.$video, {left:0});

    } else {

        console.log("pw > 1400 ");

        var pCh = pw / ratio;
        var top = (ph - pCh) / 2;

        console.log("---- ph " + ph + " pcH "+ pCh + " top "+ top);

        TweenMax.set(self.$videoContainer, {width:pw, height: pCh, top: top, left:0});
        TweenMax.set(self.$video, {left:-5});

    }


};
MainCarousel.prototype.showHideImage = function(image){

    this.$previousImage.html(this.$currentImage.html());

    TweenMax.set(this.$currentImage, {autoAlpha:0});
    TweenMax.to(this.$currentImage, 0.75, {autoAlpha:1});

    this.$currentImage.html(image);

};



